module.exports = __webpack_public_path__ + "static/media/11.15c9d27f.jpg";